import React from 'react';
import PropTypes from 'prop-types';

import { ModalContent, ModalHeader, ModalLayout, Overlay } from '@sitebase/ui-kit';
import XIcon from '@wh/svg-icons/X';
import { withTranslator } from '@wh/ui-translations';

import ChangeComponentList from '../ChangeComponentList';

import './changeComponentModal.scss';

const ChangeComponentModal = ({
    events,
    closeModal,
    t,
    eventId,
    sportName,
    locale,
    competitionName,
    onClickEventItem,
}) => (
    <Overlay styleName="change-component-modal__overlay">
        <ModalLayout outfit="full-screen">
            <ModalHeader
                actionSlot={
                    <span styleName="change-component-modal__close_button" data-test="closeButton" onClick={closeModal}>
                        {t('ui-kit', 'common')('close')}
                        <XIcon />
                    </span>
                }
            >
                {competitionName}
            </ModalHeader>
            <ModalContent noPadding>
                <ChangeComponentList
                    events={events}
                    currentEventId={eventId}
                    sportName={sportName}
                    locale={locale}
                    onClickEventItem={onClickEventItem}
                />
            </ModalContent>
        </ModalLayout>
    </Overlay>
);

export const changeComponentModalPropTypes = {
    competitionName: PropTypes.string.isRequired,
    eventId: PropTypes.string.isRequired,
    events: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            startDateTime: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
        })
    ).isRequired,
    locale: PropTypes.string.isRequired,
    sportName: PropTypes.string.isRequired,
};

ChangeComponentModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    onClickEventItem: PropTypes.func.isRequired,
    ...changeComponentModalPropTypes,
};

export default withTranslator(ChangeComponentModal);
